import { DetailedHTMLProps, ThHTMLAttributes } from 'react';
import { ThSortIconContent, ThSortIconWrapper, ThSortWrapper } from './styled';

type ThSortProps<T> = DetailedHTMLProps<
  ThHTMLAttributes<HTMLTableCellElement>,
  HTMLTableCellElement
> & {
  sortKey: T;
  sortState?: {
    key: string;
    direction?: GetInitRunningTradeSort;
  };
  onSort?: (key: T, direction: GetInitRunningTradeSort) => void;
};

const ThSort = <T,>({
  children,
  sortKey,
  sortState,
  onSort,
  ...props
}: ThSortProps<T>) => {
  const { key, direction } = sortState ?? {};
  const nextDirection = key === sortKey && direction === 'asc' ? 'desc' : 'asc';

  if (!onSort) return <th {...props}>{children}</th>;

  return (
    <th
      {...props}
      style={{ ...props?.style, cursor: 'pointer' }}
      onClick={() => onSort(sortKey, nextDirection)}
    >
      <ThSortWrapper>
        {children}
        <ThSortIconWrapper>
          <ThSortIconContent active={key === sortKey && direction === 'asc'}>
            <AscIcon />
          </ThSortIconContent>
          <ThSortIconContent active={key === sortKey && direction === 'desc'}>
            <DescIcon />
          </ThSortIconContent>
        </ThSortIconWrapper>
      </ThSortWrapper>
    </th>
  );
};

const AscIcon = () => (
  <svg
    viewBox="0 0 1024 1024"
    focusable="false"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"></path>
  </svg>
);

const DescIcon = () => (
  <svg
    viewBox="0 0 1024 1024"
    focusable="false"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path>
  </svg>
);

export default ThSort;
